import queryString from "query-string";

export const createPath = (path: string, searchParams: URLSearchParams, extraParams: Record<string, any> = {}) => {
    const currentParams = Object.fromEntries(searchParams.entries());

    const combined = { ...currentParams, ...extraParams };

    if (!extraParams.id) delete combined.id;

    const query = queryString.stringify(combined, { skipEmptyString: true, skipNull: true, encode: false });
    const cleanPath = path.startsWith("/") ? path : `/${path}`;

    return `/admin${cleanPath}${query ? `?${query}` : ""}`;
};